import React from 'react'
import { useTranslation } from 'react-i18next';

// MUI
import LaunchIcon from '@mui/icons-material/Launch';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { RequestPage } from '@mui/icons-material';
import { PhotoCamera } from '@mui/icons-material';

// Custom
import MapCardActionButton from '@/ui/MapCard/MapCardActionButton';
import Permissions from '@/lib/permissions';

// Types
import { TShowButton3D } from '@/@types/views/map'


const ShowButton3D = (props: TShowButton3D) => {
  const { t } = useTranslation();
  const { type, recordId, disabled } = props;

  const baseUrl = window.location.origin;

  const openUrl = (path: string) => {
    window.open(`${baseUrl}${path}`, '_blank');
  };

  if (type === 'lokacija') {
    return (
      <MapCardActionButton
        startIcon={<RequestPage />}
        onClick={() =>
          recordId &&
          openUrl(`/ena/utility/?open_first=true&loc_id=${recordId}`)
        }
        disabled={disabled}
        needPermission={[Permissions.Ena]}
        tooltip="tooltips.buttons.show_ko"
      >
        {t('buttons.show_ko')}
        <LaunchIcon style={{ marginLeft: 7, width: 16, height: 16 }} />
      </MapCardActionButton>
    );
  }

  if (type === 'grobno_mjesto') {
    return (
      <>
        <MapCardActionButton
          startIcon={<AssignmentIndIcon />}
          onClick={() =>
            recordId &&
            openUrl(`/groblja/registar-grobnih-mjesta-korisnici?id=${recordId}`)
          }
          disabled={disabled}
          needPermission={[Permissions.Groblja]}
          tooltip="tooltips.buttons.show_korisnici"
        >
          {t('buttons.show_korisnici')}
        </MapCardActionButton>

        <MapCardActionButton
          startIcon={<AssignmentIndIcon />}
          onClick={() =>
            recordId &&
            openUrl(`/groblja/registar-grobnih-mjesta-ukopani?id=${recordId}`)
          }
          disabled={disabled}
          needPermission={[Permissions.Groblja]}
          tooltip="tooltips.buttons.show_ukopani"
        >
          {t('buttons.show_ukopani')}
        </MapCardActionButton>
        <MapCardActionButton
          startIcon={<PhotoCamera />}
          onClick={() =>
            recordId &&
            openUrl(`/groblja/photodoc?rec_id=${recordId}`)
          }
          disabled={disabled}
          needPermission={[Permissions.Groblja]}
          tooltip="tooltips.buttons.show_photos"
        >
          {t('buttons.show_photos')}
        </MapCardActionButton>
      </>
    );
  }

  return null;
};

export default ShowButton3D